import type { ReactNode } from 'react';

/**
 * The header bar of a Sample Transfer bespoke popup: the accent strip with the
 * title on the left and the **close ✕ on the right**, exactly as the legacy XAF
 * popup renders it (owner report 2026-09-28 — our popups had the title only, so
 * the only way out was Cancel or Esc).
 *
 * One component for every `.stx-modal` so the bar can never drift between the
 * Received Date / Attachment / Note / Sample Condition Check / Remark popups
 * (standing rule 8 — shared, never per-popup markup).
 */
export function StxModalHead({ title, onClose }: { title: ReactNode; onClose: () => void }) {
  return (
    <div className="stx-modal-head">
      <span>{title}</span>
      {/* Plain ✕ CHARACTER, exactly like the shared <AppDialog> .ad-close — the
          Tabler `ti-x` webfont glyph was rendering invisible at rest (only on
          hover), so a real character is used instead (owner report 2026-09-29). */}
      <button type="button" className="stx-modal-x" title="Close" aria-label="Close" onClick={onClose}>
        ✕
      </button>
    </div>
  );
}
